import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10 text-center">
          <span className="text-xs font-semibold text-secondary-500 uppercase tracking-wider">❓ FAQ</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">常见问答</h2>
          <p className="text-sm text-foreground-500 mt-1">关于漫漫漫画的使用疑问，这里都有答案</p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer border-0 bg-transparent"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{item.q}</h3>
                <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 ${
                  openIndex === idx
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}